import { Button, Tabs } from "@aidkitorg/component-library";
import React from "react";
import { CreateDashboardComponentTab } from "./CreateDashboardComponentTab";
import { useLocalizedStrings } from "../../../Localization";

const TemplatesTab = () => {
  const L = useLocalizedStrings()

  return (<div className="min-h-64 items-center justify-center flex">
    <div className="text-gray-700 px-4 text-center">
      <div className="font-medium">
        {L.admin_panel.dashboards.templates_on_the_way}
      </div>
      <div>
        {L.admin_panel.dashboards.templates_msg}
      </div>
    </div>
  </div>)
}

export const DashboardBuilderPanel = () => {
  const L = useLocalizedStrings()
  
  const tabs = [
    { name: L.admin_panel.dashboards.create , key: 'create', content: <CreateDashboardComponentTab /> },
    { name: L.admin_panel.dashboards.templates, key: 'templates', content: <TemplatesTab /> },
  ]
  return (<>
    <Tabs unmountTabs tabs={tabs} />
  </>)
}